import React from "react";
import BingoPlayersList from "../components/BingoPlayersList";
import Bingo from "../../../assets/images/bingo/Bingo.png";
import _ from "lodash";

const Joining = ({ users, gameParams }) => {
  const how_label = _.get(gameParams, "1_joining.waiting_label", "WAITING FOR PLAYERS TO JOIN");
  return (
    <div className="profile-container">
      <div className="bingo-lobby-header">
        <img src={Bingo} alt="text-img" />
        <p className="waiting-txt">{how_label}</p>
      </div>
      <div className="player-profile-wrapper2">
        <BingoPlayersList players={users} />
      </div>
    </div>
  );
};

export default Joining;
